import React, {useCallback, useEffect, useState} from 'react'
import { withRouter } from 'react-router'
import ConfigForm from './form'
import './index.css'

const isDevelopment = process.env.REACT_APP_API_URL.indexOf('staging') >= 0 || process.env.REACT_APP_API_URL.indexOf('localhost') >= 0
const PublicTimeline = () => {
    const [config, setConfig] = useState({
        $el: '#publicTimeline',
        listMaxHeight: '300',
        locale: 'en',
        market: 'en'
    })

    const updateConfig = useCallback((field, value) => {
        setConfig((prevState) => ({
            ...prevState,
            [field]: value
        }))
    }, [])

    useEffect(() => {
        const script = document.createElement('script')

        script.src = `https://fortunica-data.s3.eu-central-1.amazonaws.com/widgets/public-timeline/${!isDevelopment ? '' : 'stage/' }index${!isDevelopment ? '.min': ''}.js`
        script.async = true
        document.body.appendChild(script)

        const sheet = document.createElement('link')
        sheet.rel = 'stylesheet'
        sheet.href = `https://fortunica-data.s3.eu-central-1.amazonaws.com/widgets/public-timeline/${!isDevelopment ? '' : 'stage/' }index${!isDevelopment ? '.min': ''}.css`
        sheet.type = 'text/css'
        document.head.appendChild(sheet)

        let scriptInit;
        script.onload = () => {
            scriptInit = document.createElement('script')
            scriptInit.type = 'text/javascript';
            scriptInit.async = true
            scriptInit.innerHTML = `FortunicaPublicTimeline.init(${JSON.stringify(config)})`

            document.body.appendChild(scriptInit)
        };

        return () => {
            document.body.removeChild(script)
            document.head.removeChild(sheet)

            if (scriptInit) {
                document.body.removeChild(scriptInit)
            }

            if (window.FortunicaPublicTimeline) {
                window.FortunicaPublicTimeline.unmount()
            }
        }
    }, [config]);

    return (
        <div className="widget-container">
            <div id="publicTimeline" className="widget-box" style={{ margin: '10px auto', maxWidth: 500 }} />
            <div className="widget-form">
                <div className="widget-config-title">Public timeline config</div>
                <ConfigForm config={config} updateConfig={updateConfig} />
            </div>
        </div>
    )
}

export default withRouter(PublicTimeline)



// WEBPACK FOOTER //
// ./src/components/widgets/public-timeline/index.js